const socialLinks = [
  // {
  //   name: 'Telegram',
  //   username: '@shobhagarg',
  //   url: 'https://t.me/shobhagarg',
  //   icon: 'logos:telegram',
  //   color: 'from-blue-200 to-blue-400',
  //   hoverColor: 'hover:from-blue-400 hover:to-blue-500',
  //   bgColor: 'bg-blue-50 dark:bg-blue-950/30',
  //   textColor: 'text-blue-600 dark:text-blue-400',
  // },
  {
    name: 'Email',
    username: 'gargshobha5@gmail.com',
    url: 'mailto:gargshobha5@gmail.com',
    icon: 'mdi:email',
    color: 'from-red-500 to-pink-500',
    hoverColor: 'hover:from-red-600 hover:to-pink-600',
    bgColor: 'bg-red-50 dark:bg-red-950/30',
    textColor: 'text-red-600 dark:text-red-400',
},
  {
    name: 'GitHub',
    username: 'shobha-garg',
    url: 'https://github.com/shobha-garg',
    icon: 'mdi:github',
    color: 'from-violet-600 to-fuchsia-600',
    hoverColor: 'hover:from-violet-700 hover:to-fuchsia-700',
    bgColor: 'bg-violet-600 dark:bg-fuchsia-600',
    textColor: 'text-gray-800 dark:text-gray-300',
  },
{
  name: 'LinkedIn',
  username: 'Shobha Garg',
  url: 'https://linkedin.com/in/shobhagarg',
  icon: 'mdi:linkedin',
  color: 'from-blue-300 to-blue-500',
  hoverColor: 'hover:from-blue-400 hover:to-blue-600',
  bgColor: 'bg-blue-50 dark:bg-blue-950/30',
  textColor: 'text-blue-700 dark:text-blue-400',
},
];

export default socialLinks;